export { InboxIn as default } from './InboxIn';
